import { render, staticRenderFns } from "./election-candidate-filter-component.vue?vue&type=template&id=81014f82&scoped=true"
import script from "./election-candidate-filter-component.ts?vue&type=script&lang=ts&external"
export * from "./election-candidate-filter-component.ts?vue&type=script&lang=ts&external"
import style0 from "./election-candidate-filter-component.scss?vue&type=style&index=0&id=81014f82&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81014f82",
  null
  
)

export default component.exports